import * as React from 'react';
import { History } from 'history';
import Model from './menu-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps {
  history: History;
  root?: string;
  caption?: string;
  captionThin?: boolean;
  currentId?: number;
  menugroupId?: number;
  cardCount?: number;
  cardIconOnly?: boolean;
  autoLoad?: boolean;
  autoSelect?: boolean;
  onLoad?: (data: any) => void;
  disableBackButton?: boolean;
}

interface IState {
  datarow: Model;
  currentId: number;
  historyLengthRoot: number;
  menuPage: number;
}

export default class MenuPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { 
      datarow: Model.defaultValue(),
      currentId : this.props.currentId || 0,
      historyLengthRoot: 0,
      menuPage:  1,
    }
    
    this.onChangePage = this.onChangePage.bind(this);
  }

  private historyState: any = this.props.history.location.state;
  private isMobile: boolean = AppService.isMobile();
  private isRootPath = () => this.props.history.location.pathname === this.props.root;
  
  private onLoad = async(data: any) => {
    const menuUrl = (this.props.root||'') + data.path.split(';')[0];
    
    if (!this.props.root || this.isRootPath())
      this.props.history.push(menuUrl, AppService.historyState());

    else {
      //Before Go to New Menu Url, Back to Root Page First for Clear The History
      const go = this.props.history.length - this.state.historyLengthRoot - 2;
      if (go > 0) await this.props.history.go(-go);
      await setTimeout(() => this.props.history.replace(menuUrl, AppService.historyState('historyLength', this.state.historyLengthRoot + 2)), 100);
    }
    this.setState({datarow: data, currentId: data.id})
    this.props.onLoad?.(data);
  }

  private onChangePage = (value: number) => {
    AppService.historyState('menuPage', value);
    this.setState({menuPage: value})
  }

  public componentDidMount() {
    if (this.props.root){

      //Back to Previous Page First, When User Hit New Url
      if (!this.isRootPath() && !this.historyState) this.props.history.goBack();

      //Update currentId, menuPage & historyLengthRoot Base on Current History States
      if (this.historyState?.menuId) this.setState({currentId: this.historyState?.menuId})
      if (this.historyState?.menuPage) this.setState({menuPage: this.historyState?.menuPage})
      if (this.historyState?.historyLengthRoot) this.setState({historyLengthRoot: this.historyState?.historyLengthRoot})
    }
  }

  public componentDidUpdate() {
    if (this.props.root && !this.isRootPath()) {
      AppService.historyState('menuId', this.state.currentId, true);
      AppService.historyState('menuPage', this.state.menuPage, true, true);
      AppService.historyState('menugroupId', this.props.menugroupId, true, true);
    }
  }
  
  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} caption={this.props.caption} captionThin={this.props.captionThin} endPointFilter={Model.endPointFilterList2(this.props.menugroupId)} model={Model} currentId={ this.isRootPath()? -1 : this.state.currentId} onLoad={this.onLoad} page={this.state.menuPage} pageSize={this.isMobile? 6: 10} onChangePage={this.onChangePage} cardCount={this.props.cardCount || 2} cardRightArrow swipe={this.isMobile? 'vertical' : ''} cardIconOnly={this.props.cardIconOnly} autoLoad={this.isMobile || this.props.autoLoad} autoSelect={this.props.autoSelect} disableBackButton={this.props.disableBackButton} disableCard/>
    );
  }
}
